import { createAction } from 'redux-actions';
import * as types from './types';

export const addItem = createAction(types.ADD_ITEM);
export const setItem = createAction(types.SET_ITEM);
export const removeItem = createAction(types.REMOVE_ITEM);
export const clearItems = createAction(types.CLEAR_ITEMS);

export const setShipping = createAction(types.SET_SHIPPING);
